import { LOCAL_HOST_FRAGMENTS } from "./hosts";

const location = (): Location | undefined =>
	typeof window !== "undefined" ? window.location : undefined;

export const isProductionEnv = () => {
	const href = location()?.href ?? "";
	return href.indexOf("www.wevideo") > 0 || href.indexOf("eu.wevideo") > 0;
};
export const APP_VERSION = import.meta.env.VITE_PACKAGE_VERSION;
export const COMMIT_HASH = import.meta.env.VITE_COMMIT_HASH;
export const BRANCH = import.meta.env.VITE_BRANCH;

export const isLocalEnvironment = () => {
	const host = location()?.host ?? "";
	return LOCAL_HOST_FRAGMENTS.some(fragment => host.indexOf(fragment) >= 0);
};

export const isAwsTestEnvironment = () => (location()?.host ?? "").startsWith("awstest.");

export const isKeepLoggingEnabled = () => (location()?.search ?? "").indexOf("keepLogging") >= 0;

// Unknown (no navigator, or no onLine) counts as online.
export const isBrowserOnline = () => typeof navigator === "undefined" || navigator.onLine !== false;
